module.exports = __webpack_public_path__ + "static/media/pages-bg.017b03d9.png";